import { Container, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import _Slider from 'react-slick';
const Slider = (_Slider as any).default || _Slider;
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import CardSliderActor from '../../../components/cards/CardSliderActor';
import { withApollo } from '../../../hoc/withApollo';
import Link from '../../../components/Link';

const useStyles = makeStyles()((theme) => ({
  cardTitle: {
    color: '#2C367E',
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    fontSize: '2.2em',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.6em',
    },
  },
  actorContainer: {
    paddingTop: '5em',
    paddingBottom: '5em',
    textAlign: 'center',
  },
  border: {
    width: '3em',
    borderColor: '#2C367E',
    borderBottom: 'solid',
    marginLeft: '48%',
    borderBottomColor: '#2C367E',
    color: '#2C367E',
    height: '1em',
    textAlign: 'center',
  },
  buttonGrid: {
    fontSize: '1.2em',
    margin: '1.5em 0 1.5em 0 ',
    color: 'white',
    backgroundColor: '#2C367E',
    border: 'none',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.2em 3em 0.2em 3em',
    minHeight: '2.5em',
    '&:hover': {
      cursor: 'pointer',
      color: '#2C367E',
      backgroundColor: 'white',
      border: '2px solid #2C367E',
    },
    backgroundImage: "url('/arrow.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    backgroundPositionY: '-3px',
  },
  articleCarroussel: { paddingTop: '2em' },
  buttonArticle: { paddingTop: '1em', paddingBottom: '1em' },
}));

const GET_ACTORS = gql`
  query actors($limit: Int, $sort: String, $way: String, $isValidated: Boolean) {
    actors(limit: $limit, sort: $sort, way: $way, isValidated: $isValidated) {
      id
      name
      address
      lat
      lng
      url
      entries {
        label
      }
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
      }
    }
  }
`;

interface LastActorProps {
  id?: string;
}

const LastActor = ({ id }: LastActorProps) => {
  const [actorToRender, setActorToRender] = useState<{ actorData: any } | null>(null);
  const { data: actorData } = useQuery(GET_ACTORS, {
    variables: { isValidated: true, limit: 4, sort: 'createdAt', way: 'DESC' },
  });

  useEffect(() => {
    setActorToRender({ actorData });
  }, [actorData]);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { classes: styles } = useStyles();
  const maxImageDisplay = !mobile ? 5 : 1;

  const SampleNextArrow = (props: any) => (
    <div className={props.className} style={{ ...props.style, display: 'block' }} onClick={props.onClick} />
  );
  const SamplePrevArrow = (props: any) => (
    <div className={props.className} style={{ ...props.style, display: 'block' }} onClick={props.onClick} />
  );

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow:
      actorToRender?.actorData && actorToRender.actorData.actors.length > maxImageDisplay
        ? maxImageDisplay
        : actorToRender?.actorData && actorToRender.actorData.actors.length,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Container className={styles.actorContainer} id={id}>
      <Typography variant="h2" className={styles.cardTitle}>
        LES ACTEURS RÉCEMMENTS AJOUTÉS
      </Typography>
      <div className={styles.border} />
      <Slider {...settings} className={styles.articleCarroussel}>
        {actorToRender?.actorData &&
          actorToRender.actorData.actors.map((actor: any) => (
            <CardSliderActor key={actor.id} actor={actor} />
          ))}
      </Slider>
      <div className={styles.buttonArticle}>
        <Link href="/map">
          <button className={styles.buttonGrid}>VOIR TOUS LES ACTEURS</button>
        </Link>
      </div>
    </Container>
  );
};

export default withApollo()(LastActor);
